export const Theme = {
  primaryColor: '#36D3BA',
  borderColor: 'rgba(145, 145, 145, 0.36)',
  borderColorRGB: '145, 145, 145',
  checkboxBackgroundColor: '#B9B9B9',
  inputBackgroundColor: 'rgba(213, 213, 213, 0.5)',
  lightBackgroundColor: 'rgba(213, 213, 213, 0.3)',
  headlineColor: '#666666',
  textColor: '#919292',
  lightTextColor: '#C3C6C5',
  warningColor: '#F27984',
  headlineFont: 'museo-sans',
  headlineWeight: 700,
  subHeadlineWeight: 300,
  textFont: 'museo-sans',
  textWeight: 300,
  goldColor: '#C0A77F',
  greenColor: '#40D7C1',
  blueColor: '#3A506B',
  darkBlueColor: '#1C2541',
  breakpoints: {
    tablet: 950,
  },
}
